if (process.env.GATSBY_SITE === 'partners') {
  const partners = require('./gatsby-browser.partners');
  Object.assign(exports, partners);
} else {
  const main = require('./gatsby-browser.main');
  Object.assign(exports, main);
}
